import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var FooterComponent = /** @class */ (function () {
    function FooterComponent(translateService) {
        this.translateService = translateService;
        this.informationClick = new EventEmitter();
    }
    Object.defineProperty(FooterComponent.prototype, "licenseLink", {
        get: function () {
            return 'https://ec.europa.eu/info/european-union-public-licence';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "licenseIconLink", {
        get: function () {
            return 'https://creativecommons.org/licenses/by/4.0/';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "feedbackLink", {
        get: function () {
            var subject = this.translateService.instant('Contact') + ':%20' + this.title;
            return 'mailto:yhteentoimivuus@dvv.fi?subject=' + subject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "descriptionOfFileLink", {
        get: function () {
            return 'https://wiki.dvv.fi/display/YTIJD/Tietosuojaseloste';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "accessibilityLink", {
        get: function () {
            return 'https://wiki.dvv.fi/display/YTIJD/Saavutettavuusseloste';
        },
        enumerable: true,
        configurable: true
    });
    FooterComponent.prototype.showUserSupportLink = function () {
        return false;
    };
    return FooterComponent;
}());
export { FooterComponent };
